import { Component, OnInit } from '@angular/core';
import { PasswordResetForm } from '@core/authentication/models/password-reset.form';
import { PasswordResetService } from '@core/authentication/services/password-reset.service';
import { finalize } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgIf, NgFor, NgSwitch, NgSwitchCase, SlicePipe, KeyValuePipe } from '@angular/common';
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { AntButtonModule } from '@antony/ng-ui';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss'],
  imports: [
    MatCard,
    FormsModule,
    ReactiveFormsModule,
    MatCardHeader,
    MatCardTitle,
    MatCardContent,
    NgIf,
    MatFormField,
    MatLabel,
    MatInput,
    MatIcon,
    MatSuffix,
    MatError,
    NgFor,
    NgSwitch,
    NgSwitchCase,
    MatCardActions,
    AntButtonModule,
    SlicePipe,
    KeyValuePipe,
    TranslatePipe,
  ],
})
export class PasswordResetComponent implements OnInit {
  private static readonly TOKEN_PARAMETER_NAME = 't';

  labelHideBreakpoints: string[] = [];

  resetForm = new PasswordResetForm();
  showPassword = false;
  showPasswordRepeat = false;
  private submitted = false;

  constructor(
    private api: PasswordResetService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {}

  onSubmit() {
    const formValue = this.resetForm.value;
    if (this.resetForm.invalid || this.hasSubmitted() || !formValue) {
      return;
    }

    this.submitted = true;
    formValue.token = this.getTokenFromUrl();
    this.api
      .resetPassword(formValue)
      .pipe(finalize(() => (this.submitted = false)))
      .subscribe();
  }

  hasSubmitted(): boolean {
    return this.submitted;
  }

  private getTokenFromUrl(): string | null {
    const snapshot = this.activatedRoute.snapshot;
    const paramMap = snapshot.queryParamMap;
    if (!paramMap.has(PasswordResetComponent.TOKEN_PARAMETER_NAME)) {
      return null;
    }
    return paramMap.get(PasswordResetComponent.TOKEN_PARAMETER_NAME);
  }
}
